<template>
  <div class="card-contant marginTop">

    <!-- 工具栏 搜索-->
    <toolbar v-if="sourceItem.labelList && sourceItem.labelList.length > 0" ref="bar" :source-data="sourceItem.labelList" @onSonFilter="handleFilter($event,sourceItem)" />

    <!-- tabs -->
    <template v-if="sourceItem.kpiType == -2">
      <el-tabs v-if="sourceItem.kpiType == -2 && sourceItem.childs && sourceItem.childs.length > 0" v-model="sourceItem.activeTab" type="card" @tab-click="handleTabClick(sourceItem)">
        <el-tab-pane v-for="(item,index) in sourceItem.childs" :key="index" :label="item.name" :name="item.code">

          <div v-if="item.listData.listLoading" v-loading="true" style="height:350px; z-index:3" />

          <template v-else>
            <!-- 单ECharts-->
            <chart-page v-if="item.listData.echartsData && JSON.stringify(item.listData.echartsData) != '{}'" :id="item.code" :key="item.code" :height="item.height" :name="item.name" :chart-data="item.listData.data" />

            <!-- 表格-->
            <table-menu-page v-if="item.listData.tableData && JSON.stringify(item.listData.tableData) != '{}'" class="table-top" :source-data="item.listData.tableData" :source-item="item" :filter-data="filterData" :filter-sondata="filterSondata" />
          </template>

        </el-tab-pane>
      </el-tabs>
    </template>

    <template v-else>
      <div v-if="sourceItem.listData.listLoading" v-loading="true" style="height:350px;z-index:3" />

      <template v-else>

        <!-- 单ECharts-->
        <chart-page v-if="sourceItem.listData.echartsData && JSON.stringify(sourceItem.listData.echartsData) != '{}'" :id="sourceItem.code" :key="sourceItem.code" :height="sourceItem.height" :name="sourceItem.name" :chart-data="sourceItem.listData.data" />

        <!-- 表格-->
        <table-menu-page v-if="sourceItem.listData.tableData && JSON.stringify(sourceItem.listData.tableData) != '{}'" :source-data="sourceItem.listData.tableData" :source-item="sourceItem" :filter-data="filterData" :filter-sondata="filterSondata" />

      </template>
    </template>

  </div>
</template>

<script>
import TableMenuPage from '../table/tableMenuPage'
import ChartPage from '../chartPage'
import Toolbar from '../toolbar'
export default {
  name: 'ModuleCardItem',
  components: { TableMenuPage, ChartPage, Toolbar },

  props: {
    // 数据源
    sourceItem: {
      type: Object,
      default: () => {}
    },

    // 公共查询条件数据
    filterData: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      filterSondata: {} // 子查询条件
    }
  },

  watch: {
    sourceItem(val) {
      if (val.labelList && val.labelList.length > 0) {
        this.$nextTick(() => {
          this.$refs['bar'].init('son') // 初始化
        })
      }
    }
  },

  mounted() {
    // console.log('11111', this.sourceItem)
    if (this.sourceItem.labelList && this.sourceItem.labelList.length > 0) {
      this.$nextTick(() => {
        this.$refs['bar'].init('son') // 初始化
      })
    }
  },

  methods: {
    // 子查询
    handleFilter(filterSondata, list) {
      this.filterSondata = filterSondata // 子查询条件
      if (list.activeTab) {
        let item = {}
        list.childs.forEach(e => {
          if (list.activeTab == e.code) {
            e.listData = {}
            item = e
          }
        })
        this.$nextTick(() => {
          this.$emit('filterItem', item, filterSondata)
        })
      } else {
        this.$nextTick(() => {
          this.$emit('filterItem', list, filterSondata)
        })
      }
    },

    // 刷新
    handleResh(item) {
      this.$emit('handleResh', item)
    },

    // 切换tab 刷新数据
    handleTabClick(list) {
      let item = {}
      list.childs.forEach(e => {
        if (list.activeTab == e.code) {
          e.listData = {}
          item = e
        }
      })
      // console.log('tab切换：',item,this.filterSondata)

      this.$nextTick(() => {
        this.$emit('tabClick', item, this.filterSondata)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .marginTop{
        margin-top: 15px;
    }
    .card-contant{
        text-align: center;
        ::v-deep .el-tabs__item{
            height: 34px;
            line-height: 34px;
            padding: 0 12px !important;
        }
    }
    .bottom-title{
        margin-bottom: 15px;
        font-size: 14px;
    }
    .contant-item{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 10px;
        line-height: 22px;
        .item-title{
            color: #666;
            font-size: 14px;
        }
        .item-num{
            color: #666;
            font-size: 18px;
        }
    }
    .table-top{
        margin-top: 10px;
    }

    .el-loading-mask{
        z-index: 1;
    }
</style>
